import { AfterViewInit, Component, Injector } from "@angular/core";
import { RightComponentWithCollapsedPanel } from "../../tracking/right-track/right-track.component"
import { InterfacePermissions, UsersService } from "../../../services/users.service";
declare const $;

@Component({
  selector: 'app-right-history',
  templateUrl: './right-history.component.html',
  styleUrls: ['./right-history.component.css'],
  standalone: false
})
export class RightHistoryComponent extends RightComponentWithCollapsedPanel implements AfterViewInit
{
    public InterfacePermissions = InterfacePermissions;

  constructor(protected injector: Injector) {
    super(injector);
  }

  ngAfterViewInit() {
    if (!this.usersService.InterfaceIsPermitted(InterfacePermissions.REPORTS)) {
      var x = $("#bottomright .btn_tabs button");

      for (let i = 0; i < x.length; i++)
        $(x[i]).addClass("hidden");
      $("#track").removeClass("hidden");
      this.openTabTrackingRight('table_info', 2);
    } else {
      this.openTabTrackingRight('table_objects_stat', 1);
    }
  }
  public openTabTrackingRight(tabName: string, headNum: number) {
    var x = $("#bottomright .tabpage");
    for (let i = 0; i < x.length; i++)
      $(x[i]).addClass("hidden");

    $("#" + tabName).removeClass("hidden");

    x = $(".history .righttrack .btn_tabs button");
    for (let i = 0; i < x.length; i++)
      $(x[i]).removeClass("active");
    $(x[headNum - 1]).addClass("active");

    //$(window).trigger('resize');
  }
}
